import { render } from "./TituloLealtadNew.vue?vue&type=template&id=37f358d1&scoped=true"
import script from "./TituloLealtadNew.vue?vue&type=script&lang=js"
export * from "./TituloLealtadNew.vue?vue&type=script&lang=js"

import "./TituloLealtadNew.vue?vue&type=style&index=0&id=37f358d1&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f358d1"]])

export default __exports__